import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";
import OrganizationTicketsPerBranchReport from "../../../components/organization/reports/daily/OrganizationTicketsPerBranch";

const OrganizationTicketsPerBranch = ({
  showFilterForm = true,
  reportIndex = 1,
}) => {
  const { reportRange, loading, tickets } = useSelector(
    (state) => state.defaultReducer
  );
  const title = `${reportIndex}. Tickets Per Branch`;
  console.log(title);
  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{title}</h1>
              <p>{getReportDescription(reportRange).TicketsByBranch}</p>

              <OrganizationTicketsPerBranchReport reportIndex={reportIndex} />
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default OrganizationTicketsPerBranch;
